module.exports = __webpack_public_path__ + "img/i_o_my_bell.54c02e1b.svg";